/* eslint-disable */
import qs from 'qs';
import axiosClient from './axiosClient';
import {
  ProductionImagesIndexPost,
} from '../types/productionImages';

/**
 * 画像URLとbase64をFileに変換
 */
export async function dataUrlToFile(dataUrl: string, fileName: string): Promise<File> {
  console.log(dataUrl);
  const res: Response = await fetch(dataUrl, {method: 'GET', mode: 'cors',});
  const blob: Blob = await res.blob();
  return new File([blob], fileName, { type: blob.type });
}

/**
 * 投稿作品画像サービス
 */
class ProductionImageService {
  /**
   * 投稿作品画像登録
   * @param input
   */
   public async updateWorkImages(id: number, input: ProductionImagesIndexPost): Promise<any> {
    // console.log(this);
    // console.log(input);
    const url = `works/images/${id}`;
    const data = new FormData();
    if (input.productionImages && input.productionImages.length > 0) {
      let i = 0;
      for (const productImage of input.productionImages){
        if (productImage.image){
          const file = await dataUrlToFile(productImage.image, '画像');
          data.append(`contentsBase64[${i}]`, file);
          i += 1;
        }
      }
    }
    try {
      const response = await axiosClient.post<any>(url, data);
      return response.data;
    } catch (err: any) {
      console.log(err);
      return err.response.data;
    }
  }
}
export default new ProductionImageService();
